var _path, _path2, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonday({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 -50 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.846 153.489a31.97 31.97 0 01-27.86-16.167 30.911 30.911 0 01.875-31.823l57.373-90.096A31.993 31.993 0 0190.556.015a31.932 31.932 0 0127.41 16.896c5.349 10.113 4.68 22.28-1.725 31.774L58.904 138.78a31.982 31.982 0 01-27.058 14.709z",
    fill: "#F62B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.256 153.488c-11.572 0-22.22-6.187-27.812-16.13a30.814 30.814 0 01.875-31.737l57.264-89.89A31.944 31.944 0 01188.93.016c11.669.255 22.244 6.782 27.592 16.993a30.813 30.813 0 01-2.066 31.92l-57.252 89.889a31.933 31.933 0 01-26.948 14.671z",
    fill: "#FC0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#00CA72",
    cx: 226.466,
    cy: 125.324,
    rx: 29.538,
    ry: 28.918
  })));
}

export default SvgMonday;